var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector82(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 320,
    viewBox: "0 0 342 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.407 318.535C316.17 298.933 312.329 294.664 296.975 274.551C293.213 269.624 287.294 260.044 281.641 248.212C279.947 244.672 278.411 241.161 277.002 237.699C266.957 212.924 265.539 185.168 267.873 157.758C273.831 87.8191 235.973 24.6964 178.655 6.29468C121.238 -12.1366 57.4785 18.1855 26.367 65.5029C22.3193 71.6598 4.46389 100.713 1.82449 132.589C-6.53692 233.233 90.9537 273.45 239.292 303.9C242.178 304.49 255.917 306.742 258.832 307.145L340.417 318.544L340.407 318.535Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector82);
export default __webpack_public_path__ + "static/media/vector8-2.82cda66b1b62d7a3913986e9c881a156.svg";
export { ForwardRef as ReactComponent };